// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"f8d6cfd7","167":"17193fcc","273":"fc768b56","436":"5c471dd8","583":"9b6cfbcd","858":"15de1274","881":"7b44dcc9","970":"668d1222"}[chunkId] + ".chunk.js";
};